export const getAppDetailsUrl = (slug: string, origin = ''): string =>
  `${origin}/${slug}`

export const getCategoryUrl = (slug: string, origin = ''): string =>
  `${origin}/categories/${slug}`

export const getCollectionUrl = (slug: string, origin = ''): string =>
  `${origin}/collections/${slug}`

export const getAppDetailsTabUrl = (
  tabId: string,
  originWithPath: string,
): string => `${originWithPath}#${tabId}`
